import type { BusinessServiceItem } from "@/api/types";
import { formatCents } from "@/features/dashboard/clients/constants";

/** List price — design uses bold lime at 15px (e.g. $85). Falls back to cents when display string missing. */
export function formatServiceListPrice(service: BusinessServiceItem): string {
  const display = service.price_display?.trim();
  if (display) {
    return display;
  }
  if (service.price_cents != null) {
    return formatCents(service.price_cents, service.currency || "USD");
  }
  return "—";
}

export function formatServiceDuration(minutes: number | null): string {
  if (minutes == null || minutes <= 0) {
    return "—";
  }
  return `${minutes} min`;
}

/** Mobile edit chrome subheader: `Name · Category`. */
export function formatServiceChromeSubtitle(
  name: string,
  category: string,
  options?: { newServiceFallback?: string },
): string | undefined {
  const trimmedName = name.trim();
  const trimmedCategory = category.trim();

  if (trimmedName && trimmedCategory) {
    return `${trimmedName} · ${trimmedCategory}`;
  }
  if (trimmedName) {
    return trimmedName;
  }
  if (trimmedCategory) {
    return trimmedCategory;
  }
  return options?.newServiceFallback;
}
